<div class="container">
  <mat-card class="mat-card-2" *ngIf="isLoading">
    <mat-label>Saving data, please wait...</mat-label>
    <mat-spinner mode="indeterminate"></mat-spinner>
  </mat-card>
  <mat-card *ngIf="!isLoading">
    <label class="header-label">
      <mat-icon class="primary-color">supervisor_account</mat-icon>
      Personal Information
    </label>
    <form [formGroup]="clientProfile" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input matInput type="name" formControlName="firstName" />
        <!-- <mat-error *ngIf="studentForm.controls['firstName'].invalid">You must enter a value</mat-error> -->
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Last Name</mat-label>
        <input matInput type="name" formControlName="lastName" />
        <!-- <mat-error *ngIf="studentForm.controls['lastName'].invalid">You must enter a value</mat-error> -->
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Email Id</mat-label>
        <input
          matInput
          type="email"
          placeholder="xyz@gmail.com"
          formControlName="email"
        />
        <!-- <mat-error *ngIf="studentForm.controls['email'].invalid">{{getErrorMessage()}}</mat-error> -->
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Mobile Number</mat-label>
        <input
          matInput
          type="number"
          placeholder="91XXXXXXXXXX"
          formControlName="phoneNumber"
        />
        <mat-hint>Enter number with country code (without +)</mat-hint>
        <!-- <span matTextPrefix><span class="fi fi-in"></span>&nbsp;+91&nbsp;</span> -->
        <!-- <mat-error *ngIf="studentForm.controls['phoneNumber'].invalid && !invalidNum">You must enter a value</mat-error>
        <mat-error *ngIf="studentForm.controls['phoneNumber'].invalid && invalidNum">Please enter a valid number</mat-error> -->
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Client Type</mat-label>
        <mat-select matNativeControl required formControlName="clientType">
          <mat-option *ngFor="let m of clientTypes" [value]="m">{{
            m
          }}</mat-option>
        </mat-select>
        <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Select Package</mat-label>
        <mat-select matNativeControl required formControlName="package">
          <mat-option *ngFor="let m of dietPackages" [value]="m.id">
            {{ m.value }}
          </mat-option>
        </mat-select>
        <!-- <mat-error *ngIf="studentForm.controls['package'].invalid">You must select a value</mat-error> -->
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Package Amount</mat-label>
        <input matInput type="text" formControlName="packageAmnt" />
        <span matTextPrefix><strong>₹</strong>&nbsp;</span>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Amount Received</mat-label>
        <input matInput type="text" formControlName="amntReceived" />
        <span matTextPrefix><strong>₹</strong>&nbsp;</span>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Amount Received Date</mat-label>
        <input
          matInput
          [matDatepicker]="amntReceivedDate"
          formControlName="amntReceivedDate"
        />
        <mat-datepicker-toggle matIconSuffix [for]="amntReceivedDate">
          <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #amntReceivedDate></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Amount Remaining</mat-label>
        <input matInput type="text" formControlName="amntRemaining" />
        <span matTextPrefix><strong>₹</strong>&nbsp;</span>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Remaining Amount Due Date</mat-label>
        <input
          matInput
          [matDatepicker]="amntRemainingDate"
          formControlName="amntRemainingDate"
        />
        <mat-datepicker-toggle matIconSuffix [for]="amntRemainingDate">
          <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #amntRemainingDate></mat-datepicker>
      </mat-form-field>
      <!-- <mat-form-field appearance="outline">
        <mat-label>Package Amount</mat-label>
        <mat-select matNativeControl required formControlName="packageAmnt">
          <mat-option *ngFor="let m of selectedPackage?.value" [value]="m.id">
            {{ selectedPackage.id === "Domestic" ? "INR - " : "USD - "
            }}{{ m.value }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
      <mat-form-field appearance="outline">
        <mat-label>Package Start Date</mat-label>
        <input
          matInput
          [matDatepicker]="packageStartDate"
          formControlName="packageStartDate"
        />
        <mat-datepicker-toggle matIconSuffix [for]="packageStartDate">
          <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #packageStartDate></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Package End Date</mat-label>
        <input
          matInput
          [matDatepicker]="packageEndDate"
          formControlName="packageEndDate"
        />
        <mat-datepicker-toggle matIconSuffix [for]="packageEndDate">
          <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #packageEndDate></mat-datepicker>
        <!-- <mat-error *ngIf="studentForm.controls['packageEndDate'].invalid">You must enter a value</mat-error> -->
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Assign Dietician </mat-label>
        <mat-select matNativeControl required formControlName="assignDietician">
          <mat-option *ngFor="let emp of employee$ | async" [value]="emp.name">
            {{ emp.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Assign Co Dietician </mat-label>
        <mat-select
          matNativeControl
          required
          formControlName="assignCoDietician"
        >
          <mat-option *ngFor="let emp of employee$ | async" [value]="emp.name">
            {{ emp.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Client Timezone</mat-label>
        <mat-select formControlName="clientTimezone">
          <div class="sticky-input-container">
            <input
              class="input-search"
              placeholder="search timezones"
              type="text"
              (input)="onFilter($event)"
            />
          </div>
          <mat-option *ngFor="let tz of filteredTZ" [value]="tz">{{
            tz
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="btn-row">
        <!-- <button mat-raised-button class="secondary-btn" (click)="saveForm('personalInfo')">Save for later <img [src]="saveIcon"></button> -->
        <button mat-raised-button class="primary-btn">
          Submit <img [src]="submitIcon" />
        </button>
      </div>
    </form>
  </mat-card>
</div>
